import * as React from 'react';
import { Subscription } from 'rxjs';

import { translate } from 'components/translate-hoc';
import { IContent } from './content.types';
// components
import ContentView from './subcomponents/content-view.component';
// services
import ubisoftOverlayService from 'modules/ubisoft-overlay-service';
// styles
import './content.styles.less';

export class Content extends React.Component<IContent> {
    private overlayLogoutSubsription: Subscription;
    private overlayLoginSubsription: Subscription;

    public componentDidMount() {
        this.overlayLoginSubsription = ubisoftOverlayService
            .overlayLoginTriggerSubject
            .subscribe(this.onOverlayLoginChange);

        this.overlayLogoutSubsription = ubisoftOverlayService
            .overlayLogoutTriggerSubject
            .subscribe(this.onOverlayLogoutChange);
    }

    public componentWillUnmount() {
        this.overlayLoginSubsription.unsubscribe();
        this.overlayLogoutSubsription.unsubscribe();
    }

    public onOverlayLogoutChange = () => {
        const { logOut } = this.props;
        return logOut && logOut();
    };

    public onOverlayLoginChange = () => {
        const { requestLoginSession } = this.props;
        return requestLoginSession && requestLoginSession();
    };

    public render() {
        const { shouldInheritStyles, children } = this.props;
        
        return <ContentView shouldInheritStyles={shouldInheritStyles}>{children}</ContentView>;
    }
}

export default translate()(Content);
